
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetogoaurbaniaonrent() {



    const cardData =
    {
        keyword: 'Pune to Goa Urbania On Rent',
        heading: 'Amruta Travels: Pune to Goa Urbania On Rent',
        headingDescription: 'Amruta Travels offers Pune to Goa Urbania on Rent, providing a luxurious and spacious travel solution for your beach getaway, group tour, or special event. Whether you are planning a family vacation, friends trip, corporate retreat, or wedding travel, our Force Urbania vans ensure a comfortable and scenic ride from Pune to the vibrant shores of Goa.',


        top: 'Top Places to Visit in Outstation Goa with Amruta Travels',



"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "One of the most popular beaches in North Goa, Baga Beach is known for its vibrant nightlife, water sports, beach shacks, and music. It's perfect for jet skiing, banana boat rides, and soaking in the beach party vibes."
  },
  {
    "title": "Calangute Beach",
    "description": "Often called the 'Queen of Beaches,' Calangute is the largest beach in North Goa. Ideal for swimming and sunbathing, it also offers shopping stalls, local eateries, and adventure activities."
  },
  {
    "title": "Fort Aguada",
    "description": "A 17th-century Portuguese fort overlooking the Arabian Sea, Fort Aguada is a historic structure that offers scenic views and a glimpse into Goa’s colonial past. It also houses a centuries-old lighthouse."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "A UNESCO World Heritage Site, this church in Old Goa holds the mortal remains of St. Francis Xavier. It's renowned for its baroque architecture and spiritual significance."
  },
  {
    "title": "Anjuna Beach",
    "description": "Famous for its hippie vibe, Anjuna Beach is ideal for backpackers and adventure seekers. It also hosts a weekly flea market where you can shop for handicrafts, jewelry, and souvenirs."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Located on the Goa-Karnataka border, Dudhsagar is a spectacular four-tiered waterfall surrounded by lush greenery. It's best visited during the monsoon season and accessible via trekking or jeep rides."
  },
  {
    "title": "Chapora Fort",
    "description": "Known for the iconic scene from the Bollywood movie 'Dil Chahta Hai,' this fort offers breathtaking views of Vagator Beach and the Arabian Sea, making it a popular sunset point."
  },
  {
    "title": "Palolem Beach",
    "description": "A serene crescent-shaped beach in South Goa, Palolem is famous for its laid-back vibe, dolphin-spotting trips, and eco-huts. It’s perfect for peaceful getaways and kayaking."
  },
  {
    "title": "Colva Beach",
    "description": "Located in South Goa, Colva Beach is popular for its white sand stretches, vibrant nightlife, and a mix of locals and tourists. It’s great for swimming and beach walks."
  },
  {
    "title": "Shri Mangeshi Temple",
    "description": "One of the largest and most frequently visited Hindu temples in Goa, the Mangeshi Temple is dedicated to Lord Shiva. It's known for its elegant architecture and religious importance."
  }
],

   "services": [
    {
      "name": "Tempo Traveller Urbania on Rent",
      "description": "Rent a Tempo Traveller Urbania from Amruta Travels for group trips within Pune or long-distance travels. Our Urbania vehicles come with comfortable seating, AC, and ample space, making them perfect for any journey."
    },
    {
      "name": "Pune to Goa 13 Seater Urbania on Rent",
      "description": "Travel from Pune to Goa with ease by renting a 13-seater Urbania from Amruta Travels. Perfect for small groups, this vehicle offers a comfortable and luxurious ride, equipped with air conditioning and spacious seating."
    },
    {
      "name": "Pune to Goa 17 Seater Urbania on Rent",
      "description": "For larger groups traveling from Pune to Goa, Amruta Travels offers a 17-seater Force Urbania for rent. Ideal for family trips or corporate outings, this Urbania provides AC comfort, ample space, and professional drivers."
    },
    {
      "name": "Pune to Goa Urbania Packages",
      "description": "Amruta Travels offers customized Urbania packages for your trip from Pune to Goa. Choose from our flexible packages, including options for 13, 17, or larger Urbania vehicles, ensuring a smooth and comfortable journey to the beaches of Goa."
    },
    {
      "name": "Pune to Kolhapur Urbania Hire",
      "description": "Book a Force Urbania for your journey from Pune to Kolhapur. Our rental service ensures a comfortable and air-conditioned trip, whether you're heading to Kolhapur for a pilgrimage, business trip, or leisure travel."
    },
    {
      "name": "Pune to Panchgani Urbania Bus On Rent",
      "description": "Travel to Panchgani in comfort with Amruta Travels' Urbania rentals. Whether you're planning a family outing or a group trip, our Urbania vehicles provide an air-conditioned, comfortable ride, perfect for the scenic drive to Panchgani."
    },
    {
      "name": "Pune to Tapola Urbania Bus On Rent",
      "description": "Explore Tapola with Amruta Travels' Force Urbania rental service. Offering spacious seating, air conditioning, and a smooth ride, our Urbania buses are the best choice for group travel to Tapola."
    },
    {
      "name": "Pune to Goa Urbania Bus 2 Days Package",
      "description": "Amruta Travels offers a special 2-day package for your Goa trip, including a Force Urbania bus. Travel in style and comfort with our 17-seater or larger Urbania vehicles, perfect for exploring Goa’s beaches and nightlife."
    },
    {
      "name": "Pimpri Chinchwad to Goa Urbania Bus on Rent",
      "description": "Travel from Pimpri Chinchwad to Goa with Amruta Travels' Urbania rental service. Our 17-seater vehicles are perfect for group trips, providing AC comfort, spacious interiors, and a smooth ride to Goa."
    },
    {
      "name": "Force Urbania Luxury Mini Bus On Rent",
      "description": "Rent a Force Urbania luxury mini bus for your group trips with Amruta Travels. With AC, comfortable seating, and a professional driver, our Urbania vehicles offer the ultimate travel experience for any occasion."
    },
    {
      "name": "Force Urbania on Rent in Pune",
      "description": "Rent a Force Urbania from Amruta Travels for your trip within Pune or to nearby destinations. Our fleet includes 13-seater, 17-seater, and other capacities to suit your needs, offering air conditioning and comfortable interiors."
    },
    {
      "name": "Pune to Mahabaleshwar Urbania Bus Hire",
      "description": "Rent a Force Urbania for your Mahabaleshwar trip from Pune with Amruta Travels. Offering a comfortable, air-conditioned ride, our Urbania vehicles are perfect for a scenic and smooth journey to Mahabaleshwar."
    },
    {
      "name": "Pune to Kas Pathar Urbania Bus On Rent",
      "description": "Explore the natural beauty of Kas Pathar with Amruta Travels' Urbania rentals. Our comfortable, air-conditioned Force Urbania vehicles ensure a pleasant and scenic trip from Pune to Kas Pathar."
    },
    {
      "name": "Pune to Wai Satara Urbania Bus on Rent",
      "description": "Travel comfortably from Pune to Wai Satara with Amruta Travels' Urbania bus hire. Whether it's a family trip or corporate outing, our Urbania vehicles provide air-conditioned comfort and plenty of space for your group."
    },
    {
      "name": "Pune to Goa 10 Seater Urbania on Rent",
      "description": "For smaller groups traveling to Goa, Amruta Travels offers a 10-seater Force Urbania for rent. Enjoy the scenic drive to Goa in comfort, with air conditioning and ample space for your group."
    },
    {
      "name": "Pune to Goa Urbania 2 Days Package",
      "description": "Amruta Travels offers a 2-day package for your trip to Goa, including a Force Urbania vehicle. Choose from 13-seater, 17-seater, or larger options for a comfortable, air-conditioned ride to one of India’s most popular beach destinations."
    }
  ],
  "tableData": [
    ["Tempo Traveller Urbania on Rent", "Pune to Goa 13 Seater Urbania on Rent"],
    ["Pune to Goa 17 Seater Urbania on Rent", "Pune to Goa Urbania Packages"],
    ["Pune to Kolhapur Urbania Hire", "Pune to Panchgani Urbania Bus On Rent"],
    ["Pune to Tapola Urbania Bus On Rent", "Pune to Goa Urbania Bus 2 Days Package"],
    ["Pimpri Chinchwad to Goa Urbania Bus on Rent", "Force Urbania Luxury Mini Bus On Rent"],
    ["Force Urbania on Rent in Pune", "Pune to Mahabaleshwar Urbania Bus Hire"],
    ["Pune to Kas Pathar Urbania Bus On Rent", "Pune to Wai Satara Urbania Bus on Rent"],
    ["Pune to Goa 10 Seater Urbania on Rent", "Pune to Goa Urbania 2 Days Package"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Luxurious Urbania Rentals for Pune to Goa",
    "WhyChoosedescription": "Amruta Travels offers premium Urbania vans on rent for your journey from Pune to Goa, ensuring a luxurious, comfortable, and hassle-free travel experience. With spacious interiors, plush seating, and modern amenities, our Urbania vans make the long road trip to Goa relaxing and enjoyable."
  },
  {
    "WhyChooseheading": "Perfect for Family Trips, Corporate Outings, and Group Travel",
    "WhyChoosedescription": "Whether you're heading to Goa for a family vacation, corporate retreat, or a group getaway, our Urbania vans provide ample space for passengers and luggage. The vehicles are designed to ensure your group travels comfortably and arrives in style."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for Pune to Goa Trips",
    "WhyChoosedescription": "We offer competitive and transparent pricing for Urbania van rentals from Pune to Goa. Our all-inclusive rates cover fuel, tolls, driver fees, and taxes—no hidden charges, so you can easily manage your travel budget without any surprises."
  },
  {
    "WhyChooseheading": "Professional Drivers for Safe and Efficient Travel",
    "WhyChoosedescription": "Our experienced drivers are skilled in navigating long-distance routes, ensuring that your journey from Pune to Goa is safe, smooth, and timely. They are well-versed in the best routes, traffic conditions, and ensuring a comfortable ride for all passengers."
  },
  {
    "WhyChooseheading": "Modern Features for a Comfortable Long-Distance Journey",
    "WhyChoosedescription": "Our Urbania vans are equipped with premium features, including air conditioning, plush seating, entertainment systems, USB charging ports, and ample space for luggage. These features ensure that your journey from Pune to Goa—whether it's a 9-10 hour drive—is as comfortable as possible."
  },
  {
    "WhyChooseheading": "Ideal for Extended Road Trips and Leisure Travel",
    "WhyChoosedescription": "The Urbania van is the perfect vehicle for long road trips like the one from Pune to Goa. With comfortable seating, ample space for luggage, and modern amenities, it is well-equipped for a leisurely trip, allowing you to sit back, relax, and enjoy the scenic journey."
  },
  {
    "WhyChooseheading": "Easy Online Booking and Flexible Rental Duration",
    "WhyChoosedescription": "Booking an Urbania van for your Pune to Goa trip is simple and quick through Amruta Travels. Our easy-to-use online platform allows you to book your rental, customize your itinerary, and receive instant confirmation. We offer flexible rental durations for both one-way trips and extended stays."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Stress-Free Journey",
    "WhyChoosedescription": "Amruta Travels provides 24/7 customer support to handle all your inquiries and provide assistance with any last-minute changes. Whether it's a question about the route, vehicle details, or booking adjustments, our team is here to make your Pune to Goa journey smooth and stress-free."
  }
]





















    }

const faqData = [
  {
    question: 'Can I rent a Force Urbania for a trip from Pune to Goa with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers Force Urbania rentals for trips from Pune to Goa. Our Urbania minibuses are perfect for comfortable and stylish group travel for long journeys like Pune to Goa.',
  },
  {
    question: 'What seating capacities are available for the Force Urbania from Pune to Goa?',
    answer: 'We provide Force Urbania minibuses with seating capacities of 13 and 17 seats, ideal for small to medium-sized groups traveling from Pune to Goa.',
  },
  {
    question: 'Is a driver included with the Force Urbania rental for Pune to Goa?',
    answer: 'Yes, all Force Urbania rentals for Pune to Goa include a professional, experienced driver who ensures a safe, smooth, and comfortable journey.',
  },
  {
    question: 'How much does it cost to rent a Force Urbania for a Pune to Goa trip?',
    answer: 'The rental cost depends on factors like seating capacity, trip duration, and distance. Rates typically start from ₹35 per km for a 13-seater and ₹38 per km for a 17-seater. For an exact quote, contact us with your travel details.',
  },
  {
    question: 'How long does the trip from Pune to Goa take in a Force Urbania?',
    answer: 'The journey from Pune to Goa usually takes around 8 to 10 hours, depending on the traffic and route conditions. The Force Urbania offers a relaxing and comfortable ride throughout the trip.',
  },
  {
    question: 'Are the Force Urbania vehicles well-maintained and sanitized for the Pune to Goa trip?',
    answer: 'Yes, all our Force Urbania vehicles are regularly maintained and thoroughly sanitized before each trip. We prioritize safety, cleanliness, and comfort to ensure a pleasant journey.',
  },
  {
    question: 'Can I book a Force Urbania online for a Pune to Goa trip?',
    answer: 'Yes, booking a Force Urbania for your Pune to Goa trip is easy. You can book it through our website or by contacting our team. We will guide you through the booking process and help with any requirements.',
  },
  {
    question: 'Is the Force Urbania suitable for a family or group trip to Goa?',
    answer: 'Absolutely! The Force Urbania is a great option for group trips to Goa, providing ample space, comfort, and luxury. It’s perfect for family vacations, corporate outings, or friends traveling together.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rajesh Kumar',
    role: 'Business Owner, Pune',
    text: 'We rented a 17-seater Force Urbania for a family trip from Pune to Goa. The vehicle was spacious, clean, and very comfortable. The driver was courteous, and the whole experience was fantastic. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Shah',
    role: 'Travel Blogger, Pune',
    text: 'Our trip from Pune to Goa in the Force Urbania was perfect! The ride was smooth and comfortable. The vehicle was well-maintained, and the driver was friendly and professional. A great experience!',
    rating: 5,
  },
];













































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Urbania On Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-goa-urbania-on-rent.jpg", // Update with actual image URL
  "description": "Rent a Force Urbania for your trip from Pune to Goa. Available in 13, 17, and 10-seater options for a comfortable and luxurious journey. Book for weekend getaways, 2-day packages, or family trips to Goa, Kolhapur, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000", // Adjust price as per service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-goa-urbania-on-rent"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune to Goa Urbania On Rent | Force Urbania 13 Seater, 17 Seater | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent a luxury Force Urbania for your Pune to Goa trip. Choose from 13, 17, or 10-seater options. Book a 2-day Goa package or a weekend getaway now!" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/75.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogoaurbaniaonrent;